/* eslint-disable no-unused-vars */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import SwapVerticalCircleOutlinedIcon from '@material-ui/icons/SwapVerticalCircleOutlined';
import parse from 'html-react-parser';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { getHTMLTextFromNormalText } from '../../../../catalog/Website';
import './css/ShippingReturnPolicyComponent.css';

const ShippingReturnPolicyComponent = (props) => {
    const { showShipping, showReturn, shippingPolicy, returnPolicy } = props;
    const { globalState } = useContext(context);

    const getShippingPolicy = () => {
        if (isValidObject(shippingPolicy) && shippingPolicy !== '-1') {
            return shippingPolicy;
        }

        if (isValidString(globalState.policies.shipping)) {
            return globalState.policies.shipping;
        }

        return '';
    };

    const getReturnPolicy = () => {
        if (isValidObject(returnPolicy) && returnPolicy !== '-1') {
            return returnPolicy;
        }

        if (isValidString(globalState.policies.return)) {
            return globalState.policies.return;
        }

        return '';
    };

    return (
        <div className="shipping-return-policy-component">
            {showShipping && isValidString(getShippingPolicy()) ? (
                <Accordion className="shipping-return-policy-accordian">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="shipping-policy-content"
                        id="shipping-policy-header"
                    >
                        <div className="shipping-return-policy-accordian-summary">
                            <LocalShippingOutlinedIcon style={{ marginRight: '10px' }} />
                            <p className="roboto-font-family text-uppercase font-size-l">Shipping Policy</p>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p className="alegreya-font-family font-weight-200 text-left-align">{parse(getHTMLTextFromNormalText(getShippingPolicy()))}</p>
                    </AccordionDetails>
                </Accordion>
            ) : null}
            {showReturn && isValidString(getReturnPolicy()) ? (
                <Accordion className="shipping-return-policy-accordian">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="return-policy-content"
                        id="return-policy-header"
                    >
                        <div className="shipping-return-policy-accordian-summary">
                            <SwapVerticalCircleOutlinedIcon style={{ marginRight: '10px' }} />
                            <p className="roboto-font-family text-uppercase font-size-l">Return Policy</p>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p className="alegreya-font-family font-weight-200 text-left-align">{parse(getHTMLTextFromNormalText(getReturnPolicy()))}</p>
                    </AccordionDetails>
                </Accordion>
            ) : null}

        </div>
    );
};

ShippingReturnPolicyComponent.propTypes = {
    showShipping: PropTypes.bool,
    showReturn: PropTypes.bool,
    shippingPolicy: PropTypes.string,
    returnPolicy: PropTypes.string,

};

ShippingReturnPolicyComponent.defaultProps = {
    showShipping: true,
    showReturn: true,
    shippingPolicy: '',
    returnPolicy: '',
};

export default memo(ShippingReturnPolicyComponent);
